// Displays the grid of image thumbnails, (need to check lazy load function when there's more images to play with 14/05/2025 EP

// Import react elements
import { useState } from 'react';

// Import components
import ImageCard from './ImageCard';



// ImageGrid component
const ImageGrid = ({

    paginatedImageData,
    handleImageSelect,
    selectedImages,
    thumbnailSize,
    showSeeMoreSlot,
    currentPage,
    setCurrentPage,
    imageGridTopRef,
    showBackCard = false,
    onBack,
    onOpenChildren,
    loadingBucketId,
    currentParentId,
    onMoveImage,
    movingBucketItemId,
    onDeleteImage

}) => {

    // Track whether the Back card is currently being used as a detach target.
    const [backDropTarget, setBackDropTarget] = useState(false);



    return (

            <div className={`image-grid image-grid--${thumbnailSize}`} ref={imageGridTopRef}>

                {/* Keep a filesystem-style back card visible while browsing associated files. */}
                {showBackCard &&

                    <button
                        type="button"
                        className={`image-card image-card--back ${backDropTarget ? 'image-card--drop-target' : ''}`}
                        onClick={onBack}
                        onDragOver={(event) => {

                            // Allow child bucket items to be detached by dropping them onto Back.
                            event.preventDefault();
                            event.dataTransfer.dropEffect = 'move';
                            setBackDropTarget(true);

                        }}
                        onDragLeave={() => setBackDropTarget(false)}
                        onDrop={(event) => {

                            // Stop the browser's normal drop behaviour.
                            event.preventDefault();
                            setBackDropTarget(false);

                            // Get the public bucket id stored by ImageCard.
                            const imageId = event.dataTransfer.getData('text/plain');

                            // Ignore empty drags and the current parent itself.
                            if (!imageId || String(imageId) === String(currentParentId)) return;

                            // Null explicitly detaches this child back to the root.
                            onMoveImage(imageId, null);

                        }}
                    >

                        <div className="image-card__back-icon">

                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M3.5 7h6l2 2h9v10h-17z" />
                                <path d="M10 12.5H6.5" />
                                <path d="M8.5 10.5l-2 2 2 2" />
                            </svg>

                        </div>

                        <div className="image-card__name">Back</div>

                    </button>

                }

                {/* Map through all images */}
                {paginatedImageData.map((img, index) => (

                    <ImageCard
                        key={img.id}
                        image={img}
                        index={index}
                        handleImageSelect={handleImageSelect}
                        selected={selectedImages.includes(img.id)}
                        onOpenChildren={onOpenChildren}
                        childrenLoading={String(loadingBucketId) === String(img.id)}
                        childrenNavigationDisabled={String(currentParentId) === String(img.id)}
                        dragDisabled={movingBucketItemId !== null}
                        allowParentDrop={!showBackCard}
                        onMoveImage={onMoveImage}
                        onDelete={onDeleteImage}
                    />

                ))}

            {/* Check if we need to show a 'see more images' image card (there's more page/s to see!) - onClick go to next page */}
            {showSeeMoreSlot && 
                                
                <div className="image-card--see-more-slot" onClick={() => setCurrentPage(currentPage + 1)}>

                    See more images...

                </div>
            
            }
            

            </div>

    );

};

export default ImageGrid;